import request from '@/services/interceptor.js'

export const get_tipi_disegno = () => {
    return request({ url: '/tipi-disegno', method: 'get', loadingBar: true })
}

export const get_tipo_disegno = (id) => {
    return request({ url: `/tipi-disegno/${id}`, method: 'get', loadingBar: true })
}

export const create_tipo_disegno = (par) => {
    return request({ url: '/tipi-disegno', method: 'post', data: par, loadingBar: true })
}

export const update_tipo_disegno = (id, par) => {
    return request({ url: `/tipi-disegno/${id}`, method: 'put', data: par, loadingBar: true })
}

export const delete_tipo_disegno = (id) => {
    return request({ url: `/tipi-disegno/${id}`, method: 'delete', loadingBar: true })
}

export const crea_parametro_disegno = (tipoDisegnoId, par) => {
    return request({ url: `/tipi-disegno/${tipoDisegnoId}/parametri`, method: 'post', data: par, loadingBar: true })
}

export const aggiorna_parametro_disegno = (tipoDisegnoId, id, par) => {
    return request({ url: `/tipi-disegno/${tipoDisegnoId}/parametri/${id}`, method: 'put', data: par, loadingBar: true })
}

export const elimina_parametro_disegno = (tipoDisegnoId, id) => {
    return request({ url: `/tipi-disegno/${tipoDisegnoId}/parametri/${id}`, method: 'delete', loadingBar: true })
}
